export const NAME = 'toolbar';

export const INIT_TOOLBAR_REQUEST = 'INIT_TOOLBAR_REQUEST';
export const INIT_TOOLBAR_SUCCESS = 'INIT_TOOLBAR_SUCCESS';
export const INIT_TOOLBAR_FAILURE = 'INIT_TOOLBAR_FAILURE';

export const URL_CHROME = '';
export const URL_FIREFOX = '';
export const URL_EDGE = '';
export const URL_SAFARI = '';



// WEBPACK FOOTER //
// ./src/services/toolbar/constants.js